/**
 * @generated SignedSource<<8b4d294b3da830bfec54ad76f26fe076>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Image_image$data = {
  readonly id: string;
  readonly sizes: ReadonlyArray<{
    readonly height: number;
    readonly id: string;
    readonly url: string;
    readonly urlExpiresAt: string | null;
    readonly width: number;
  }>;
  readonly thumbhash: string | null;
  readonly " $fragmentType": "Image_image";
};
export type Image_image$key = {
  readonly " $data"?: Image_image$data;
  readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Image_image",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbhash",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageSize",
      "kind": "LinkedField",
      "name": "sizes",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlExpiresAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "height",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "width",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Image",
  "abstractKey": null
};
})();

(node as any).hash = "d0ab673efd8cd9c5492027b0c75c0cf1";

export default node;
